import React from 'react'
import HeadImg from "./header.png"

const Header = () => {
    return (
        <div className="blogs-details-container-header">
            <img src="https://picsum.photos/200/300" />
            <p>Artist Feature: Malaysia</p>
        </div>
    )
}

export default Header
